import React from "react";
import { useTranslation } from "react-i18next";

const IntroSection = ({ text }) => {
  const { t } = useTranslation("result");
  return (
    <div className="py-10 flex flex-col gap-6 px-[20rem] md-max:px-[1rem]">
      <p className="text-3xl md-max:text-2xl font-semibold">{t("introduction")}</p>
      <p className="text-xl md-max:text-[16px] leading-[32px]">
       {text}
      </p>
    </div>
  );
};

export default IntroSection;
